<script setup>
import { computed, toRefs } from 'vue';
import AppApiInfoCodeBlock from './ApiInfoCodeBlock.vue';

const props = defineProps({
  url: {
    type: String,
    default: '',
  },
});

const { url } = toRefs(props);

const cursorCode = computed(() => {
  const mcpDetails = JSON.stringify({ url: url.value }, null, 2);
  return `"cc-mcp": ${mcpDetails}`;
});
const windsurfCode = computed(() => {
  const mcpDetails = JSON.stringify({ serverUrl: url.value }, null, 2);
  return `"cc-mcp": ${mcpDetails}`;
});
const claudeCode = computed(() => {
  const mcpDetails = JSON.stringify(
    {
      command: 'npx',
      args: ['mcp-remote', url.value],
    },
    null,
    2
  );
  return `"cc-mcp": ${mcpDetails}`;
});

const vsCodeCode = computed(() => {
  const mcpDetails = JSON.stringify(
    {
      url: url.value,
    },
    null,
    2
  );
  return `"cc-mcp": ${mcpDetails}`;
});
</script>
<template>
  <div>
    <div class="mb-4">
      Integrate this action with AI agents using our MCP (model context
      protocol) support.
    </div>
    <app-api-info-code-block header="URL endpoint:" :code="url" />
    <div class="mb-4 mt-6">Example use cases:</div>
    <app-api-info-code-block
      header="Cursor IDE:"
      header-icon="/logos/cursor.svg"
      :code="cursorCode"
    />
    <app-api-info-code-block
      header="Windsurf IDE:"
      header-icon="/logos/windsurf.svg"
      :code="windsurfCode"
    />
    <app-api-info-code-block
      header="Claude Desktop:"
      header-icon="/logos/claude-ai.svg"
      :code="claudeCode"
    />
    <app-api-info-code-block
      header="Cline:"
      header-icon="/logos/cline.svg"
      :code="vsCodeCode"
    />
    <app-api-info-code-block
      header="Roocode:"
      header-icon="/logos/roocode.svg"
      :code="vsCodeCode"
    />
  </div>
</template>
